export const X_GRIDS = 9;

export const Y_GRIDS = 9;

export const TILE_SIZE = 38;

export const HERO_INIT_POS = [
  { posX: 2, posY: 7 },
  { posX: 4, posY: 7 },
  { posX: 6, posY: 7 },
  { posX: 2, posY: 1 },
  { posX: 4, posY: 1 },
  { posX: 6, posY: 1 },
];

export const HERO_INIT_ISO_POS = {
  isoPosZ: 28,
};

export const HERO_INIT_FRAME_LEFT = 65;

export const HERO_INIT_FRAME_RIGHT = 91;

export const HERO_MOVING_SPEED = 150;
